/**
 * The short-lived cache of an approval form's recent requests.
 *
 * ApprovalDetail keeps the list in sessionStorage for a few minutes, because
 * finding it can cost Lark dozens of calls. The entries hold applicant names, so
 * they are dropped when the session ends rather than left for whoever signs in
 * next in the same tab — which is why the key and the clearing live together
 * here, where the auth store can reach them.
 */
const PREFIX = 'automadoc-approval-requests:'

export function approvalRequestsCacheKey(templateId: string): string {
  return `${PREFIX}${templateId}`
}

export function clearApprovalRequestsCache(): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i)
      if (key?.startsWith(PREFIX)) sessionStorage.removeItem(key)
    }
  } catch {
    // No sessionStorage (private mode, a locked-down webview): nothing was cached.
  }
}
